import React from 'react'

function Third() {
  return (
<section className="third">
    <div className="container">
        <div className="inner-wrapper d-flex align-items-center justify-content-between mb-5">
            <div className="left-col">
                <img src="/logo.png" alt="Crazy Monkey Slot Logo"/>
            </div>
            <div className="right-col">
                <p className="text">
                    For de som setter pris på en visuelt engasjerende opplevelse, tilbyr Crazy Monkey Slot fargerike og dynamiske spillscener som gjør hvert øyeblikk underholdende. Spillet har livlige farger og interaktive elementer som skaper en engasjerende atmosfære. Dette sosiale spillet er designet utelukkende for underholdningsformål og gir en avslappende opplevelse uten økonomisk risiko.
                </p>
            </div>
        </div>
        <p className="text text-md">
            Crazy Monkey Slot tilbyr en komplett og underholdende spillopplevelse. Dykk inn i den fargerike verdenen av sosial spilling og nyt hvert øyeblikk. Med støtte for både mobile enheter og datamaskiner er spillet tilgjengelig når og hvor det passer deg. Crazy Monkey Slot gir gratis underholdning og en morsom opplevelse fra komforten av ditt eget hjem.
        </p>
    </div>
</section>


  )
}

export default Third